<template>
  <v-container fluid>
    <v-card>
      <v-toolbar dense style="background:#F5F5F5">
        <v-toolbar-title dense style="color:#607D8B;font-weight:bold">Liste des commandes retardées
        </v-toolbar-title>
      </v-toolbar>

      <v-col class="text-center" sm="12">
        <v-progress-linear
            :active="loading"
            :indeterminate="loading"
            absolute
            color="#01579B"
            top
        ></v-progress-linear>
      </v-col>
      <v-data-table
          :expanded.sync="expanded"
          :footer-props="{
              showFirstLastPage: true,
              firstIcon: 'mdi-arrow-collapse-left',
              lastIcon: 'mdi-arrow-collapse-right',
              prevIcon: 'mdi-minus',
              nextIcon: 'mdi-plus'
            }"
          :headers="headers"
          :items="pendingscmd"
          :items-per-page="15"
          :search="search"
          :single-expand="singleExpand"
          no-data-text="Aucun résultat"
          no-results-text="Aucun résultat"
          show-expand
      >
        <template v-slot:[`top`]>
          <v-toolbar :elevation="0" class="mt-4 mb-4" color="white" flat>
            <v-btn large
            >
              <download-csv :data="pendingscmd" name="pendingscmd.csv">
                <v-icon class="mr-1">mdi-download-circle-outline</v-icon>
                Télécharger CSV
              </download-csv>
            </v-btn
            >
            <v-spacer></v-spacer>
            <v-text-field :id="dynamicID()"
                          append-icon="search"
                          hide-details
                          label="Rechercher..."
                          single-line
                          v-model="search"
            ></v-text-field>
          </v-toolbar>
        </template>
        <template v-slot:[`expanded-item`]="{ headers, item }">
          <td :colspan="headers.length">
            <vue-json-pretty :data="item"></vue-json-pretty>
          </td>
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <v-chip :color="getColor(item.status)" dark>{{ item.status }}</v-chip>
        </template>
        <template v-slot:[`item.createdDate`]="{ item }">
          {{ item.createdDate | formatDate }}
        </template>
        <template v-slot:[`item.pendingDate`]="{ item }">
          {{ item.pendingDate | formatDate }}
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import apiClient from "../../config/api.js";

function isMobileDevice() {
  return /Mobi|Android/i.test(navigator.userAgent);
}

export default {
  data() {
    return {
      isMobile: isMobileDevice(),
      loading: true,
      pendingscmd: [],
      search: "",
      headers: [
        {text: "ID", value: "id", sortable: false},
        {text: "Date Création", value: "createdDate", width: "200px"},
        {text: "Numéro carte", value: "cardNumber", width: "200px"},
        {text: "Emetteur", value: "senderId", sortable: false},
        {text: "Commande", value: "command", sortable: false},
        {text: "Date d'attente", value: "pendingDate", width: "200px"},
        {text: "Envoyée", value: "status", sortable: false},
        {text: "statut", value: "state", sortable: false},
        {text: "ID requête", value: "idRequest", sortable: false, width: "200px"},
        {text: "Créateur", value: "createUser", width: "200px"},
      ],
      expanded: [],
      singleExpand: true,
    };
  },
  created() {
    apiClient
        .get(`${this.$store.getters.user.baseUrl}/command/postpone/all/lamine`)
        .then((response) => {
          setTimeout(() => (this.loading = false), 3000);
          this.pendingscmd = response.data.datas;
        })
        .catch(() => {
          this.loading = false;
        });
  },
  methods: {
    getColor(val) {
      if (val === "N") return "red";
      else if (val === "Y") return "green";
      else return "green";
    },
    dynamicID() {
      return 'dynamicID-' + Math.floor(Math.random() * Date.now().toString());
    },
  },
};
</script>
<style scoped>
tbody tr:nth-of-type(even) {
  background-color: rgba(236, 237, 237);
}

tbody tr:nth-of-type(odd) {
  background-color: rgb(250, 250, 250);
}
</style>